<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <v-form class="pa-6" ref="form">
        <ReviewPublication :mod-op_id="modOp_id" :publication="publication" />
        <v-row>
          <v-col cols="12">
            <h3 class="mt-15 mb-0">
              {{ $t("title.bookAndChapterData") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <h5>
              {{ $t("form.title") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.title"
                  :label="$t('form.title')"
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <h5>
              {{ $t("form.bookandchapter.type") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-select
                  outlined
                  v-model="publication.bookAndChapter.type"
                  :label="$t('form.bookandchapter.type')"
                  :items="bookAndChapterTypes"
                  readonly
                  item-value="value"
                  item-text="text"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <h5>{{ $t("editorial") }}</h5>
            <v-row>
              <v-col class="py-0">
                <v-select
                  outlined
                  v-model="publication.bookAndChapter.editorial"
                  :label="$t('editorial')"
                  :items="editorials"
                  readonly
                  item-value="id"
                  item-text="name"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <h5>
              {{ $t("form.bookandchapter.num_pages") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="publication.bookAndChapter.num_pages"
                  :label="$t('form.bookandchapter.num_pages')"
                  required
                  readonly
                  outlined
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <h5>
              {{ $t("form.bookandchapter.publication_date") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  outlined
                  v-model="publication.bookAndChapter.publication_date"
                  :label="$t('form.bookandchapter.publication_date')"
                  prepend-inner-icon="event"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <h5>{{ $t("form.editors") }}</h5>
        <SelectPeopleList
          :disabled-form="true"
          :items-selected="publication.bookAndChapter.editors"
        />
        <h5>
          {{ $t("form.bookandchapter.editors_text") }}
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="publication.bookAndChapter.editors_text"
              :label="$t('form.bookandchapter.editors_text')"
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.bookandchapter.book_location") }}
        </h5>
        <v-row>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.bookAndChapter.book_location.chapter"
              :label="$t('form.bookandchapter.chapter')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.bookAndChapter.book_location.page_number"
              :label="$t('form.bookandchapter.pageNumber')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.bookAndChapter.book_location.page_start"
              :label="$t('form.bookandchapter.pageStart')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.bookAndChapter.book_location.page_end"
              :label="$t('form.bookandchapter.pageEnd')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <DirectorActions
      v-if="isAuthorize"
      :object_type="object_type"
      class="mt-6"
    />
    <SupervisorActions
      v-else
      :item="publication"
      :object_type="object_type"
      :form_name="form_name"
      :state="state"
      :supervisor="supervisor !== null ? supervisor.username : ''"
      @change-state-supervisor="onStateSupervisorChange"
      class="mt-6"
    />
  </div>
</template>

<script>
import axios from "axios";
import changeState from "../../../mixins/changeState";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ReviewPublication from "./ReviewPublication";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  mixins: [changeState, publication_model],
  components: {
    ReviewPublication,
    SupervisorActions,
    DirectorActions,
    SelectPeopleList
  },

  data: () => ({
    form_name: "newBookAndChapterForm",
    state: "",
    title: "",
    supervisor: "",
    object_id: null,
    object_type: "publication",
    modOp_id: null,
    publication: {
      title: "",
      abstract: "",
      keywords: "",
      doi: "",
      isbn: "",
      links: "",
      authorsrel: [],
      authors_text: "",
      bookAndChapter: {
        book_location: ""
      }
    }
  }),

  created() {
    this.getEditorials();
    this.getBookAndChapterTypes();
    this.getPublication();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  methods: {
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.supervisor = response.data.supervisor;
          this.title = response.data.title;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
